import { LatestUpdatePage } from './LatestUpdatePage'
import { withLatestUpdatePage } from './withLatestUpdatePage'

const Connected = withLatestUpdatePage(LatestUpdatePage)

export { Connected as LatestUpdatePage }
